import { Component, Inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StoreService } from 'src/app/services/infra/store/store.service';
import { LoggerService } from 'src/app/services/infra/logger/logger.service';
import { BehaviorSubject } from 'rxjs';
import { SortColumn } from 'src/app/models/sortColumn.model';
import { ITableColumn } from 'src/app/models/tableColumns';
import { MenuAction } from 'src/app/models/menuAction.model';
import { RagCleanupSummaryTableRowViewModel } from 'src/app/models/viewModels/RagCleanupSummaryTableRowViewModel';
import { ragCleanupSummaryTableColumns } from 'src/app/models/tableColumns/ragCleanupSummaryColumns.model';

export interface RagCleanupSummaryDialogData {
  excludedFiles: RagCleanupSummaryTableRowViewModel[];
}

@Component({
  selector: 'app-rag-cleanup-summary-dialog',
  templateUrl: './rag-cleanup-summary-dialog.component.html',
  styleUrls: ['./rag-cleanup-summary-dialog.component.scss'],
})
export class RagCleanupSummaryDialogComponent implements OnInit {
  public sortedColumn$ = new BehaviorSubject<SortColumn | undefined>(undefined);
  public pageInfo$ = new BehaviorSubject({
    number: 1,
    currSize: 1,
    maxSize: 2,
    totalItems: 1,
    totalPages: 1,
  });
  public isLoading$ = new BehaviorSubject<boolean>(false);
  public columns = signal<ITableColumn[]>(ragCleanupSummaryTableColumns);
  public filesCurrentPage$ = new BehaviorSubject<RagCleanupSummaryTableRowViewModel[]>([]);
  public showNoData = false;
  public totalItems = 0;
  public multiSelectedMenuActions$: BehaviorSubject<MenuAction[]> = new BehaviorSubject<MenuAction[]>([]);

  constructor(
    public dialogRef: MatDialogRef<RagCleanupSummaryDialogComponent>,
    private readonly _logger: LoggerService,
    @Inject(MAT_DIALOG_DATA) public data: RagCleanupSummaryDialogData,
    private readonly _store: StoreService
  ) {}

  ngOnInit(): void {
    this.totalItems = this.data.excludedFiles.length;
    this.showNoData = this.data.excludedFiles.length === 0;
    this.filesCurrentPage$.next(this.data.excludedFiles);
    this.pageInfo$.next({
      number: 1,
      currSize: this.data.excludedFiles.length,
      maxSize: 50,
      totalItems: this.data.excludedFiles.length,
      totalPages: 1,
    });
  }

  public onClose(): void {
    this.dialogRef.close();
  }

  public rowUnselected(): void {
    console.log('Row unselected');
  }

  public onCheckboxClick(event: Set<string>): void {
    console.log('Checkbox clicked', event);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  public rowSelected(selectedRow: any): void {}

  // eslint-disable-next-line
  public multiSelectedActionClick(menuAction: MenuAction): void {}
}
